import { useEffect } from 'react'

interface ShortcutHandlers {
  onRefresh: () => void
  onDetect: () => void
  onConfirm?: () => void
  onDismiss?: () => void
  onNext?: () => void
  onPrev?: () => void
  onHelp: () => void
  onEscape: () => void
  onTabIndex?: (index: number) => void
}

export function useKeyboardShortcuts(handlers: ShortcutHandlers) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const t = e.target as HTMLElement
      if (t?.matches?.('input, textarea, select')) return
      const k = e.key.toLowerCase()
      if (k === '?' || (e.shiftKey && k === '/')) {
        e.preventDefault()
        handlers.onHelp()
        return
      }
      if (k === 'escape') {
        handlers.onEscape()
        return
      }
      if (/^[1-6]$/.test(k) && !e.metaKey && !e.ctrlKey && !e.altKey) {
        e.preventDefault()
        handlers.onTabIndex?.(Number(k) - 1)
        return
      }
      if (k === 'r' && !e.metaKey && !e.ctrlKey) {
        e.preventDefault()
        handlers.onRefresh()
        return
      }
      if (k === 'd') {
        e.preventDefault()
        handlers.onDetect()
        return
      }
      if (k === 'j') handlers.onNext?.()
      if (k === 'k') handlers.onPrev?.()
      if (k === 'c') handlers.onConfirm?.()
      if (k === 'x') handlers.onDismiss?.()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [handlers])
}
